import { useState } from "react"

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { makePostRequest } from "request";
import { ToastContainer, toast } from 'react-toastify';


const Policy = () => {    
    // const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const [consentCheckbox, setConsentCheckbox] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const roles: any = useSelector((state: any)=> state.roles.value)
    const user: any = useSelector((state: any)=> state.tepngUser.value)

    const redirectUser = () => {
        // check if seesion storage vendorCode is set, if not set, set it
        if(sessionStorage.getItem('vendorCode') === null) sessionStorage.setItem('vendorCode', user.vendorCode)   

        // Redirect user
        const redirectURL = sessionStorage.getItem("redirectURL")
        if(redirectURL !== null) window.location.replace(redirectURL)
        else {
            if(roles?.length > 0) {
                // to avoid thirdparty users from navigating to Supplier page first
                if(roles.find((role: string) => role.toLowerCase() === "freightforwarder")) navigate("/freightforwarder/dashboard")
                else if(roles.find((role: string) => role.toLowerCase() === "localclearingagent")) navigate("/localclearingagent/dashboard")
                else navigate(`/${roles[0].toLowerCase()}/dashboard`)
            }else navigate("/rolelessuser")        
        }
        sessionStorage.removeItem("redirectURL")
    }
    
    const handleConsent = () => {
        setIsLoading(true)
        
        var request:Record<string, any> = {
            what: "AcceptConsentTerms",
            data: {
                userId: user?.id,
                acceptsConsentTerms: true
            }
        }
    
        makePostRequest(request)
            .then((response: any) => {
                setIsLoading(false)               

                setTimeout(() => {
                    toast.success(response.msg)
                    redirectUser()
                }, 500);
            }).catch((error:any) => {toast.error(error.msg); setIsLoading(false)});
    }

    return (
        <>
            <div className="blocked-container" style={{background: 'white', margin: 0}}>
                <section style={{margin: "32px 200px"}}>
                    <div className="max-w-screen-md mx-auto p-6 xs:p-4 mb-20">
                        <div className="text-center mb-6 mt-2">
                            <img width="120px" src="/trackerlogo.jpg" alt="logo" />
                            <h3 className="uppercase fw-600">Transit Tracker System | Personal Data and Cookies Consent</h3>
                        </div>

                        {/* Policy Content */}
                        <div className="p-6 xs:p-4 mb-14" style={{marginTop: "48px"}}>
                            <div className="max-w-screen-md mx-auto flex justify-between items-center">
                                <div className="text-justify text-sm" style={{textAlign: "justify"}}>
                                    <h5 style={{textTransform: "uppercase"}}>Personal Data and Cookies Charter</h5>
                                    <p className='mb-2'>
                                        <span>Welcome to the 
                                        <a style={{marginLeft: "4px", textDecoration: "none"}} href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer noopener">
                                            Transit Tracker
                                        </a></span>
                                    </p>
                                    <p className='mb-2'>
                                        The Personal Data and Cookies Charter (hereinafter Charter) aims to inform you
                                        about your rights that you can exercise regarding the processing of your data and describes
                                        the measures that we take to protect these data.
                                    </p>
                                    <p className='mb-5'>
                                        TotalEnergies EP Nigeria is the data controller with responsibility for personal data processing on the 
                                        <a style={{marginLeft: "4px", textDecoration: "none"}} href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer noopener">
                                            Transit Tracker
                                        </a>
                                        . These processing operations are carried out in accordance with the applicable law.
                                    </p>

                                    {/* 1 Purpose of processing */}
                                    <h5 className="mb-0 font-bold mt-12 underline uppercase">1. Purpose of processing, legal basis, the period of storage and types of data collected</h5>
                                    <p className='mb-2'>
                                        <span>When visiting the <a style={{textDecoration: "none"}} href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer noopener">
                                            Transit Tracker
                                        </a></span>,
                                        you may need to provide us with personal data.
                                    </p>
                                    <table className="table-auto w-full mb-5 border border-solid border-gray-300">
                                        <thead className="bg-gray-100 text-black">
                                            <tr>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Purposes</th>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Categories of personal data</th>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Legal basis</th>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Retention period</th>
                                            </tr>
                                        </thead>
                                        <tbody className='bg-white divide-y divide-gray-200'>
                                            <tr>
                                                <td className="px-4 py-2  border border-solid border-gray-300">Transit Tracker System</td>
                                                <td className="px-4 py-2  border border-solid border-gray-300">Identification data (last name, first name, email address)</td>
                                                <td className="px-4 py-2  border border-solid border-gray-300">
                                                    The information collected is necessary for the implementation of the contract with TotalEnergies EP Nigeria, failing which the contract cannot be executed.
                                                </td>
                                                <td className="px-4 py-2  border border-solid border-gray-300">As long as the person is using the application and working for TotalEnergies EP Nigeria</td>
                                            </tr>
                                        </tbody>
                                    </table>


                                    {/* 2. Recipients of the data */}
                                    <h5 className="mb-0 font-bold mt-12 underline uppercase ">2. Recipients of the data</h5>
                                    <p className='mb-5'>In order to process your personal data according to the Charter, your personal data may be communicated to one or more of the data controller's departments or to TotalEnergies company subsidiaries and one or more partners, independent distributors or subcontractors: Certain departments at TotalEnergies based on the nature of transaction</p>


                                    {/* 3. Data security and confidentiality */}
                                    <h5 className="mb-0 font-bold mt-12 underline uppercase">3. Data security and confidentiality</h5>
                                    <p className='mb-5'>The data controller takes appropriate steps to preserve the security and confidentiality of your personal data, including to prevent them from being distorted, damaged, or disclosed to unauthorized third parties.</p>



                                    {/* 4. Cookies management */}
                                    <h5 className="mb-0 font-bold mt-12 underline uppercase">4. Cookies management</h5>
                                    <p className='mb-2'>
                                        <span>A cookie is a file which enables a website to save information relating to your computer's browsing of the <a style={{textDecoration: "none", marginRight: "4px"}} href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer noopener">
                                            Transit Tracker
                                        </a></span>
                                        to make your visits to the website smoother.
                                    </p>
                                    <p className='mb-2'>
                                        <span>Cookies are text files that are stored on your computer's browser. They allow access to various information about you. Some of them belong to the publisher of the <a style={{textDecoration: "none"}} href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer noopener">
                                            Transit Tracker
                                        </a></span>
                                        (First party) and some to third parties.
                                    </p>
                                    <p>The table below details each cookie.</p>
                                    <p className='mb-2'>
                                        <span>We enable cookies once you have given your consent, except for technical cookies that are necessary to provide the service you request on the <a style={{textDecoration: "none"}} href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer noopener">
                                            Transit Tracker
                                        </a></span>
                                    </p>
                                    <table className="table-auto w-full mb-5 border border-solid border-gray-300">
                                        <thead className="bg-gray-100 text-black">
                                            <tr>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Categories of cookies and trackers</th>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Name of the cookies and trackers</th>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Objectives of the cookies and trackers</th>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Editor</th>
                                                <th className="px-4 py-2  border border-solid border-gray-300 fw-600">Retention period of the cookies and trackers</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="px-4 py-2  border border-solid border-gray-300">Technical cookie</td>
                                                <td className="px-4 py-2  border border-solid border-gray-300">TepngUserRefreshToken</td>
                                                <td className="px-4 py-2  border border-solid border-gray-300">Authentication Cookie for JavaScript Web Token Refresh</td>
                                                <td className="px-4 py-2  border border-solid border-gray-300">HttpOnly, Secure</td>
                                                <td className="px-4 py-2  border border-solid border-gray-300">24 hours</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className='font-medium mt-2'>How to withdraw your consent?</p>
                                    <p className='mb-2'>
                                        <span>On your first connection to the <a style={{textDecoration: "none"}} href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer noopener">
                                            Transit Tracker
                                        </a></span>,
                                        you will be asked to give your consent to the use of non-essentials cookies and/or to make setting. If you subsequently wish to change your choices, you can manage your cookies by going to the section at the bottom of the page of our site or application or via a reminder button called cookies.
                                    </p>
                                    <p className='mb-10'>To delete cookies already stored, please refer to the procedure provided by your operating system (Windows, OS X, etc.).</p>



                                    {/* 5. Your rights / Contact */}
                                    <h5 className="font-bold mb-0 underline uppercase mt-12">5. Your rights / Contact</h5>
                                    <p className='mb-2'>
                                        In accordance with the current regulations, you have the right to access and correct your data and to give post-mortem instructions. Regarding processing based on the performance of a contract or the implementation of pre-contractual measures, you have also the right to delete your data and to data portability and you can request a restriction of processing.
                                    </p>
                                    <p className='mb-12'>
                                        To exercise your rights and question us about your personal data processing, you can contact Human Resource
                                        <a href="mailto:ep-ng.dpl@totalenergies.com" target="_blank" rel="noreferrer noopener"> ep-ng.dpl@totalenergies.com </a>
                                        If you feel, after contacting us, that your rights have not been respected, you can lodge a complaint with the competent supervisory authority.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Consent Checkbox */}
                        <div style={{marginTop: "32px"}}>
                            <div>
                                <div className="flex gap-4">
                                    <input type="checkbox"checked={consentCheckbox} onChange={(event) => setConsentCheckbox(event.target.checked)} />                                    
                                    <label className="ml-2" style={{fontSize: "14px"}}>I have read, understood and consent to the use of my name and TotalEnergies email</label>
                                </div>
                                
                                <button style={{margin: "40px auto", width: "100%", justifyContent: "center"}} onClick={handleConsent} disabled={!consentCheckbox || isLoading} className="custom-button orange">Accept</button>
                            </div>
                        </div>
                    </div>
                </section>                
            </div>    
            <ToastContainer />    
        </>
    )
}

export default Policy